import { Route } from '@/core/router.types'

import type CourseDetails from './Details/features/CourseDetails/routes/CourseDetails'
import type CreateCycle from './Details/features/CycleSettings/routes/CreateCycle'
import type CycleDetails from './Details/features/CycleSettings/routes/CycleDetails'
import type Trainings from './Trainings'

/*****
 *
 * Trainings page routes..
 */

export default [
  {
    menu: { label: 'trainings', icon: 'FavoriteTraining' },
    path: '/trainings',
    query: '',
    authorize: ['customer_success', 'customer_manager', 'global_customer_manager'],
    flushTop: true,
    wideGutters: true,
    component: () => import('./Trainings'),
    response: (data: unknown) => ({
      title: 'Trainings',
      description: 'List of trainings in the system.',
      props: data,
    }),
  } as unknown as Route<typeof Trainings>,
  {
    path: '/trainings/cycles/create',
    query: '',
    authorize: ['customer_success', 'customer_manager', 'global_customer_manager'],
    flushTop: true,
    wideGutters: true,
    component: () => import('./Details/features/CycleSettings/routes/CreateCycle'),
    response: (data: unknown) => ({
      title: 'Create training cycle',
      description: '',
      props: data,
    }),
  } as unknown as Route<typeof CreateCycle>,
  {
    path: '/trainings/courses/:courseCode/cycles/:cycleId',
    query: '',
    authorize: ['customer_success', 'customer_manager', 'global_customer_manager'],
    flushTop: true,
    wideGutters: true,
    component: () => import('./Details/features/CycleSettings/routes/CycleDetails'),
    response: (data: unknown) => ({
      title: 'Training cycle details',
      description: '',
      props: data,
    }),
  } as unknown as Route<typeof CycleDetails>,
  {
    path: '/trainings/courses/:courseCode',
    query: '',
    authorize: ['customer_success', 'customer_manager', 'global_customer_manager'],
    flushTop: true,
    wideGutters: true,
    component: () => import('./Details/features/CourseDetails/routes/CourseDetails'),
    response: (data: unknown) => ({
      title: 'Course details',
      description: '',
      props: data,
    }),
  } as unknown as Route<typeof CourseDetails>,
] as const
